import { useState } from "react";

import { useAxiosClient } from "igfd-commons/src/http";

import { restaurantFromDoc } from "@dashboard/store/backendApis/restaurantApi";
import { FetchCallbacks } from "@dashboard/types/global";
import type {
  CreateRestaurantRequest,
  CreateRestaurantResponse,
  RestaurantWithPaymentPlan,
} from "@dashboard/types/restaurant";

export const useCreateRestaurant = ({
  onSuccess,
  onError,
  onFinish,
}: FetchCallbacks<RestaurantWithPaymentPlan, Error>) => {
  const [loading, setLoading] = useState(false);

  const axiosClient = useAxiosClient({ withAuth: true });

  const createRestaurant = async (
    createRestaurantRequest: CreateRestaurantRequest
  ) => {
    setLoading(true);
    try {
      const response = await axiosClient.post<CreateRestaurantResponse>(
        "/create-restaurant",
        createRestaurantRequest
      );

      if (response.status !== 200) {
        onError?.(
          new Error(
            `Received a non-200 response from the backend: ${response.status}`
          )
        );
      } else {
        onSuccess?.({
          restaurant: restaurantFromDoc(response.data.restaurant),
          paymentPlan: response.data.paymentPlan,
        });
      }
    } catch (error) {
      onError?.(error as Error);
    } finally {
      setLoading(false);
      onFinish?.();
    }
  };

  return { createRestaurant, loading };
};
